export default "__VITE_PUBLIC_ASSET__f244db85__"